import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_Form240 = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_Form240' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>TRANSITION PLAN</h3></center></p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Name</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>DOB</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCurrentAddress' name='txtCurrentAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Admission Date </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Planned Transition </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPlannedTransition' name='txtPlannedTransition' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Service(s) currently enrolled in </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtServiceCurrently' name='txtServiceCurrently' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Occasion of this plan: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbOccasionOfThisPlan_1' name='rbOccasionOfThisPlan' className='add-only' value='1' /> Initial Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbOccasionOfThisPlan_2' name='rbOccasionOfThisPlan' className='add-only' value='2' /> Treatment Plan Review
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbOccasionOfThisPlan_3' name='rbOccasionOfThisPlan' className='add-only' value='3' /> Transfer Level of Care
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbOccasionOfThisPlan_4' name='rbOccasionOfThisPlan' className='add-only' value='4' /> Discharge
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbOccasionOfThisPlan_5' name='rbOccasionOfThisPlan' className='add-only' value='5' /> Other &nbsp;
                            <input type='text' id='txtOccasionOfThisPlan' name='txtOccasionOfThisPlan' className='add-only w-375 custom-add-only' />
                        </td>

                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other participants:</span>
                </p>
                <p className='w-750'>Team member &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='text' id='txtOtherMember' name='txtOtherMember' className='add-only w-600 custom-add-only' /> <br />

                    Referral source &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only w-600 custom-add-only' /> <br />

                    Community resource	 &nbsp;
                    <input type='text' id='txtCommunityResource' name='txtCommunityResource' className='add-only w-600 custom-add-only' /> <br />

                    Legal &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='text' id='txtLegal' name='txtLegal' className='add-only w-600 custom-add-only' /> <br />

                    Parent/guardian &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only w-600 custom-add-only' /> <br />

                </p>

                <p className='w-750'><span className='eleHeader'>1. If transfer/discharge please specify next level of care or service, reason for discharge, etc.:</span>
                    <textarea id='txtIfTransferDischargePlease' name='txtIfTransferDischargePlease' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>2. What do I need to do to complete treatment?</span>
                    <textarea id='txtWhatDoINeedToDo' name='txtWhatDoINeedToDo' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>3. What have I accomplished on my treatment plan thus far?</span>
                    <textarea id='txtWhatHaveIAccomplished' name='txtWhatHaveIAccomplished' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>4. What have I gained from treatment so far?</span>
                    <textarea id='txtWhatIGainedTreatment' name='txtWhatIGainedTreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>5. What can I do now to improve my well-being and further my recovery?</span>
                    <span className='small'>Please identify person needs for support systems, or other services that contribute to recovery, well-being, and community integration</span>
                    <textarea id='txtWhatCanIDoNowImprove' name='txtWhatCanIDoNowImprove' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>6. Contact information for resources to meet needs mentioned in item 5.</span>
                    <span className='small'>Contact name, telephone number locations, hours, and days of service if applicable.</span>
                    <textarea id='txtContactInformationResources' name='txtContactInformationResources' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>7. List all medication including any medication changes:</span>
                    <textarea id='txtListAllMedicationIncludingAny' name='txtListAllMedicationIncludingAny' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Continuity of Service</h4>
                    <span className='small'>complete based on applicability with dates</span></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phase I</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phase II</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhase_1' name='txtPhase_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhase_2' name='txtPhase_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phase III</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Begin GED </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhase_3' name='txtPhase_3' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtBegin' name='txtBegin' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Employment </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Obtained GED </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Housing</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfEmployment' name='txtDateOfEmployment' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtObtained' name='txtObtained' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtHousing' name='txtHousing' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Reunification of Children </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliance with Probation/Parole </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtReunificationOfChildren' name='txtReunificationOfChildren' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtComplianceWithProbationParole' name='txtComplianceWithProbationParole' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>License Reinstatement </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>TANF</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLicenseReinstatement' name='txtLicenseReinstatement' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTanf' name='txtTanf' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Food Stamps </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>CAPS</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFoodStamps' name='txtFoodStamps' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtCaps' name='txtCaps' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>Referral Services</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNeighborhoodService' name='cbNeighborhoodService' className='add-only' value='Confused' /> <b>Neighborhood Service Center:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_1' name='txtContactPerson_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_1' name='txtDateOfService_1' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_2' name='txtDateOfService_2' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_3' name='txtDateOfService_3' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_4' name='txtDateOfService_4' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBoysAndGirlsClub' name='cbBoysAndGirlsClub' className='add-only' value='Confused' /> <b>YMCA/Boys & Girls Club:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_2' name='txtContactPerson_2' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_5' name='txtDateOfService_5' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_6' name='txtDateOfService_6' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_7' name='txtDateOfService_7' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_8' name='txtDateOfService_8' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGoodwillSalvation' name='cbGoodwillSalvation' className='add-only' value='Confused' /> <b>Goodwill/Salvation Army:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_3' name='txtContactPerson_3' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_3' name='txtPhone_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_9' name='txtDateOfService_9' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_10' name='txtDateOfService_10' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_11' name='txtDateOfService_11' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_12' name='txtDateOfService_12' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFoodBank' name='cbFoodBank' className='add-only' value='Confused' /> <b>Food bank:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_4' name='txtContactPerson_4' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_4' name='txtPhone_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_13' name='txtDateOfService_13' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_14' name='txtDateOfService_14' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_15' name='txtDateOfService_15' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_16' name='txtDateOfService_16' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDfcs' name='cbDfcs' className='add-only' value='Confused' /> <b>DFCS:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_5' name='txtContactPerson_5' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_5' name='txtPhone_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_17' name='txtDateOfService_17' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_18' name='txtDateOfService_18' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_19' name='txtDateOfService_19' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_20' name='txtDateOfService_20' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHealthDepartment' name='cbHealthDepartment' className='add-only' value='Confused' /> <b>Health Department: </b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_6' name='txtContactPerson_6' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_6' name='txtPhone_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_21' name='txtDateOfService_21' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_22' name='txtDateOfService_22' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_23' name='txtDateOfService_23' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_24' name='txtDateOfService_24' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProbationParole' name='cbProbationParole' className='add-only' value='Confused' /> <b>Probation/Parole:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_7' name='txtContactPerson_7' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_7' name='txtPhone_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_25' name='txtDateOfService_25' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_26' name='txtDateOfService_26' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_27' name='txtDateOfService_27' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_28' name='txtDateOfService_28' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSocialSecurityOffice' name='cbSocialSecurityOffice' className='add-only' value='Confused' /> <b>Social Security Office:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_8' name='txtContactPerson_8' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_8' name='txtPhone_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_29' name='txtDateOfService_29' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_30' name='txtDateOfService_30' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_31' name='txtDateOfService_31' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_32' name='txtDateOfService_32' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDmvServices' name='cbDmvServices' className='add-only' value='Confused' /> <b>DMV Services:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_9' name='txtContactPerson_9' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_9' name='txtPhone_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_33' name='txtDateOfService_33' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_34' name='txtDateOfService_34' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_35' name='txtDateOfService_35' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_36' name='txtDateOfService_36' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBabiesWait' name='cbBabiesWait' className='add-only' value='Confused' /> <b>Babies Can't Wait</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_10' name='txtContactPerson_10' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_10' name='txtPhone_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_37' name='txtDateOfService_37' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_38' name='txtDateOfService_38' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_39' name='txtDateOfService_39' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_40' name='txtDateOfService_40' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBabiesWait' name='cbBabiesWait' className='add-only' value='Confused' /> <b>Other Treatment Facility </b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Person</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactPerson_11' name='txtContactPerson_11' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_11' name='txtPhone_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1.&nbsp;
                            <input type='date' id='txtDateOfService_41' name='txtDateOfService_41' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2.&nbsp;
                            <input type='date' id='txtDateOfService_42' name='txtDateOfService_42' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3.&nbsp;
                            <input type='date' id='txtDateOfService_43' name='txtDateOfService_43' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>4.&nbsp;
                            <input type='date' id='txtDateOfService_44' name='txtDateOfService_44' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>Strengths/Abilities:</span>
                    <input type='text' id='txtStrengthsAbilities' name='txtStrengthsAbilities' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Needs/Preferences:</span>
                    <input type='text' id='txtNeedsPreferences' name='txtNeedsPreferences' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of person serviced or guardian if applicable:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of staff:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>






            </div>
        </form>

    )
}  
